import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';

import { colorUsage, fontSize, fontWeight, getSpacing } from 'stylesheetB2c';

interface BannerProps {
  isBannerVisible?: boolean;
}

export const StyledBanner = styled.div<BannerProps>`
  display: ${(props) => (props.isBannerVisible === false ? 'none' : 'flex')};
  flex-direction: column;
  align-items: center;

  .banner-container {
    width: 100%;
    height: ${getSpacing(10)};
    padding: ${getSpacing(2)} ${getSpacing(4)};
    background-color: ${colorUsage.bannerBackgroundColor};
    opacity: 0.95;
    border-radius: ${getSpacing(3)};
    display: flex;
  }

  .banner-content {
    flex: 1;
    margin: auto 0;
    font-size: ${fontSize.XXXSmall};
  }

  .banner-button-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: ${getSpacing(15)};
  }

  .banner-accept-button {
    height: ${getSpacing(6)};
    width: ${getSpacing(9)};
    border: none;
    border-radius: ${getSpacing(3)};
    background-color: ${colorUsage.bannerButtonBackgroundColor};
    color: ${colorUsage.whiteText};
    font-size: ${fontSize.XSmall};
    font-weight: ${fontWeight.bold};
  }

  .banner-decline-button {
    height: ${getSpacing(5)};
    padding: 0;
    border: none;
    background-color: ${colorUsage.bannerDeclineButtonBackgroundColor};
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  color: ${colorUsage.whiteText};
`;
